module.exports = __webpack_public_path__ + "img/title-right2.63e6429.png";